import React from "react";
import LayoutBasic from "../../layouts/LayoutBasic";
import Showcase from "../../modules/Showcase";

const Page0 = () => {
  return (
    <div >
    <LayoutBasic>
      <h1>Dashboard - Page 0</h1>
      <Showcase ></Showcase>
    </LayoutBasic>
    </div>
  );
};

export default Page0;
